import React from 'react';
import { Button } from '@material-ui/core';

import css from '../FeedManagment/bfm.css';

export default function DisplayXpaMessage({ closeModal}) {
  return (
    <div className={[css.w600, css.formatText].join(' ')}>
          <p>From 1 April 2024 XPA is using Access Bank Feeds to connect to your client bank transactions. Reckon Bankdata Feeds have been cancelled and will stop receiving new transactions by mid April depending on the processing time of each bank. You should download any final transactions into XPA from Reckon Bankdata before the 30th April.</p>
          <p>For bank accounts with Westpac Banking Corp Australia, please have your client log into their internet banking and cancel the feed.</p>
          <p>Please contact your CSM or <a href='mailto: aps.clientsuccess@theaccessgroup.com'>aps.clientsuccess@theaccessgroup.com</a> for more information on getting set up with Access Bank Feeds.</p>
          <div className={css.alignRight}><Button variant='contained' color='primary' size='small' onClick={closeModal}>OK</Button></div>
       </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Common/DisplayXpaMessage.js